export enum OrderTermEnum {
	DAY = 'day',
	DAY_PLUS = 'dayPlus',
	GTC = 'gtc',
	IOC = 'ioc',
	OPG = 'opg',
	CLS = 'cls',
	// FOK = 'fok',
}
